export const SRHT_EXAM_PRACTICAL_SHEET_STORAGE_PREFIX = 'srht-exam-practical-sheet-v1';
export const SRHT_EXAM_STATION_FITNESS_COORDINATION = 'fitness_coordination';
export const SRHT_EXAM_STATION_AKTIVRETTUNG = 'aktivrettung';
export const SRHT_EXAM_STATION_FALLSCHUTZ = 'fallschutz';
export const SRHT_EXAM_STATION_GRUPPENPRUEFUNG = 'gruppenpruefung';
export const SRHT_EXAM_STATION_EINZELUEBERPRUEFUNG = 'einzelueberpruefung';

const GROUP_PRUEFUNG_ALLOWED_POINTS = new Set([0, 4, 8, 12, 16, 20]);
export const GRUPPENPRUEFUNG_CUSTOM_ACTION_ID = '__custom_action__';

function buildGruppenpruefungPointOptions() {
  return [
    { points: 20, label: 'Sicheres zügiges Handeln' },
    { points: 16, label: 'Schulmäßige Durchführung' },
    { points: 12, label: 'Karabiner offen, schlechte Ordnung' },
    { points: 8, label: 'Mehrfache Fehler' },
    { points: 4, label: 'Prüfer muss unterstützen' },
    { points: 0, label: 'Nicht erfüllt / Gefährdung' },
  ];
}

export const GRUPPENPRUEFUNG_POINT_OPTIONS = buildGruppenpruefungPointOptions();

export const GRUPPENPRUEFUNG_PARTICIPANT_POSITIONS = [
  { id: 'retter_1', label: '1. Retter' },
  { id: 'retter_2', label: '2. Retter' },
  { id: 'sicherer_1', label: '1. Sicherer' },
  { id: 'sicherer_2', label: '2. Sicherer' },
];

export const FALLSCHUTZ_STANDARD_ACTIONS = [
  { id: 'patient_ansprache', order: 1, label: 'Ansprache des Patienten' },
  { id: 'festpunkte', order: 2, label: 'Erstellen von Festpunkten' },
  { id: 'abseilstrecke_patient_retter', order: 3, label: 'Abseilstrecke Patient & Retter' },
  { id: 'abseilgeraete_einbau_pruefung', order: 4, label: 'Einbau & Überprüfung von Abseilgeräten' },
  { id: 'uebernahme_patient_vorbereiten', order: 5, label: 'Verbindet sich mit Abseilstrecken in geeigneter Weise und bereitet die Übernahme des Patienten vor' },
  { id: 'seil_kantenschutz', order: 6, label: 'Installation von Seil- & Kantenschutz' },
  { id: 'absturzsicherung_kante', order: 7, label: 'Installation Absturzsicherung für die Kante' },
  { id: 'abseilgeraete_bedienung', order: 8, label: 'Bedienung von Abseilgeräten' },
  { id: 'patient_sicherung_doppelt', order: 9, label: 'Sicherung des Patienten (2-fache Sicherung)' },
  { id: 'flaschenzuege', order: 10, label: 'Einbau & Bedienung von Flaschenzügen' },
  { id: 'patient_betreuung', order: 11, label: 'Betreuung des Patienten beim Abseilvorgang' },
  { id: 'patient_lagerung', order: 12, label: 'Lagerung des Patienten außerhalb der Falllinie' },
  { id: 'kommunikation', order: 13, label: 'Kommunikation' },
  { id: 'fehlermanagement', order: 14, label: 'Fehlermanagement' },
].map((action) => ({
  ...action,
  isCustom: false,
  scoreOptions: GRUPPENPRUEFUNG_POINT_OPTIONS,
}));

export const GRUPPENPRUEFUNG_STANDARD_ACTIONS = [
  { id: 'patient_ansprache', order: 1, label: 'Ansprache des Patienten' },
  { id: 'festpunkte', order: 2, label: 'Erstellen von Festpunkten' },
  { id: 'positionierungsstrecken', order: 3, label: 'Erstellen von Positionierungsstrecken' },
  { id: 'abseilstrecke_patient', order: 4, label: 'Abseilstrecke Patient' },
  { id: 'abseilgeraete_einbau_pruefung', order: 5, label: 'Einbau und Überprüfung von Abseilgeräten' },
  { id: 'trage_vorbereitung', order: 6, label: 'Vorbereitung Trage inkl. Installation Tragenspinne' },
  { id: 'trage_einbindeknoten', order: 7, label: 'Einbindeknoten Trage inkl. Seilschwänze' },
  { id: 'seil_kantenschutz', order: 8, label: 'Installation von Seil- und Kantenschutz' },
  { id: 'trage_herausheben', order: 9, label: 'Herausheben Trage' },
  { id: 'abseilgeraete_bedienung', order: 10, label: 'Bedienung von Abseilgeräten' },
  { id: 'umbau_seilschwaenze', order: 11, label: 'Umbau in die Seilschwänze und Einstellen an der Trage' },
  { id: 'flaschenzuege', order: 12, label: 'Einbau und Bedienung von Flaschenzügen' },
  { id: 'patient_betreuung', order: 13, label: 'Betreuung des Patienten beim Abseilvorgang' },
  { id: 'kommunikation', order: 14, label: 'Kommunikation' },
  { id: 'fehlermanagement', order: 15, label: 'Fehlermanagement' },
].map((action) => ({
  ...action,
  isCustom: false,
  scoreOptions: GRUPPENPRUEFUNG_POINT_OPTIONS,
}));

export const GRUPPENPRUEFUNG_TIME_POINT_RULES = [
  { maxMs: 30 * 60 * 1000, points: 20, label: '≤ 30 min' },
  { maxMs: 35 * 60 * 1000, points: 16, label: '> 30–35 min' },
  { maxMs: 40 * 60 * 1000, points: 12, label: '> 35–40 min' },
  { maxMs: 45 * 60 * 1000, points: 8, label: '> 40–45 min' },
  { maxMs: 50 * 60 * 1000, points: 4, label: '> 45–50 min' },
];

export const FALLSCHUTZ_TIME_POINT_RULES = [
  { maxMs: 10 * 60 * 1000, points: 20, label: '≤ 10 min' },
  { maxMs: 13 * 60 * 1000, points: 16, label: '11–13 min' },
  { maxMs: 16 * 60 * 1000, points: 12, label: '14–16 min' },
  { maxMs: 19 * 60 * 1000, points: 8, label: '17–19 min' },
  { maxMs: 22 * 60 * 1000, points: 4, label: '20–22 min' },
];

export const GRUPPENPRUEFUNG_GRADE_RANGES = [
  { grade: 1, label: 'Sehr gut', min: 37, max: 40 },
  { grade: 2, label: 'Gut', min: 32, max: 36.999 },
  { grade: 3, label: 'Befriedigend', min: 27, max: 31.999 },
  { grade: 4, label: 'Ausreichend', min: 20, max: 26.999 },
  { grade: 5, label: 'Mangelhaft', min: 12, max: 19.999 },
  { grade: 6, label: 'Ungenügend', min: 0, max: 11.999 },
];

export const FALLSCHUTZ_GRADE_RANGES = [...GRUPPENPRUEFUNG_GRADE_RANGES];

export const FALLSCHUTZ_DESCRIPTION = [
  'Ein Höhenarbeiter hat bei Arbeiten auf einem Stahlträger in ca. 6 m Höhe den Halt verloren und ist in seine PSA g.A. gestürzt. Er hängt jetzt unterhalb des Stahlträgers und kann sich selbst nicht aus der Lage befreien.',
  'Der Arbeiter ist zunehmend erschöpft und verspürt erste Symptome eines Hängesyndroms, ist jedoch unverletzt. Die PSA g.A. des Arbeiters ist intakt.',
  'Zur Rettung wird eine passive Rettung von oben durchgeführt.',
  'Vor Beginn der Prüfung wird ein Seilgeländer zum Aufstieg an der Steiganlage und zum Betreten der Dachfläche erstellt und kann während der Prüfung durch die Teilnehmer genutzt werden.',
  'Die Gruppe startet auf dem Dach der Energiezentrale am Fuß der Aufstiegsleiter zum Dach.',
  'Der Einheitsführer wird durch einen Ausbilder gestellt. Die Aufgabenverteilung kann durch den Einheitsführer geändert werden.',
];

export const FALLSCHUTZ_MATERIAL = [
  'Alle TN tragen die vollständige PSA inkl. HMS-Karabiner und Prusikschlinge',
  'Jeweils ein Service-Pack je TN und Einheitsführer',
  '2x Seilsack Standard (100 m-Seil / Plane / 2x Hilfsseil 10 m)',
  '1x Materialrucksack Standard',
  '1x Hilfsseil / 20 m-Prusiksystem (Einheitsführer)',
  'Das Material steht auf dem Dach der Energiezentrale (Startpunkt der Gruppe) bereit.',
];

const GROUP_PRACTICAL_STATION_CONFIGS = {
  [SRHT_EXAM_STATION_FALLSCHUTZ]: {
    stationCardTitle: '3. Person im Fallschutz',
    heading: 'Prüfbogen 3 - Person im Fallschutz',
    description: FALLSCHUTZ_DESCRIPTION,
    material: FALLSCHUTZ_MATERIAL,
    timePointRules: FALLSCHUTZ_TIME_POINT_RULES,
    gradeRanges: FALLSCHUTZ_GRADE_RANGES,
    noTimeFailLabel: '> 22 min = 0 Punkte & nicht bestanden',
    maxDurationMs: 22 * 60 * 1000,
    standardActions: FALLSCHUTZ_STANDARD_ACTIONS,
  },
  [SRHT_EXAM_STATION_GRUPPENPRUEFUNG]: {
    stationCardTitle: '4. Tragenrettung gleiches Niveau',
    heading: 'Prüfbogen 4 - Tragenrettung gleiches Niveau',
    description: [
      'Ein Dachdecker hat auf einem Flachdach einen Bandscheibenvorfall erlitten. Er kann nur in einer Trage optimal transportiert werden, es besteht keine Anleitermöglichkeit.',
      'Zugang über Steiganlage mit kompletter Ausrüstung. Während des Abseilens kommt es zu einem fiktiven Verhaken von Retter und Patient an der Struktur, so dass ein Aufziehen von 1 m Höhe notwendig ist. Im Anschluss wird die Trage mit Retter bis auf den Boden abgelassen.',
      'Die Zeitnahme beginnt im Dachbereich der Energiezentrale am Fuß der Steigleiter und endet, wenn die Person am Boden ist.',
      'Der Gruppe werden die Funktionen 1. Retter, 2. Retter, 1. Sicherer und 2. Sicherer zugewiesen. Ein Ausbilder führt die Gruppe.',
      'Die medizinische Versorgung wird nicht abgeprüft. Aufgaben können durch den Einheitsführer situativ angepasst werden.',
      'Auf der Dachfläche sowie an der Steiganlage ist bereits vor der Prüfung ein Seilgeländer installiert, welches während der Prüfung genutzt werden kann.',
    ],
    material: [
      'Alle TN tragen die vollständige PSA inkl. HMS-Karabiner und Prusikschlinge',
      'Jeweils ein Service-Pack je TN und Einheitsführer, beim Einheitsführer zusätzlich 10 m Hilfsseil oder 20 m Prusiksystem',
      '2x Seilsack Standard (100 m-Seil / Plane / 2x Hilfsseil 10 m)',
      '2x Seil mind. 60 m in Seilsäcken',
      '1x Materialrucksack Standard',
      'Materialrucksack Patient',
      'Schleifkorbtrage',
      'Übungspuppe (90 kg) oder alternativ Patientendarsteller',
      'Das Material steht am Fuß der Steigschutzleiter (Startpunkt der Gruppe) bereit.',
    ],
    timePointRules: GRUPPENPRUEFUNG_TIME_POINT_RULES,
    gradeRanges: GRUPPENPRUEFUNG_GRADE_RANGES,
    noTimeFailLabel: '> 50 min = 0 Punkte & nicht bestanden',
    maxDurationMs: 50 * 60 * 1000,
    standardActions: GRUPPENPRUEFUNG_STANDARD_ACTIONS,
  },
};

export function isGroupPracticalStation(stationCode) {
  return Object.prototype.hasOwnProperty.call(GROUP_PRACTICAL_STATION_CONFIGS, String(stationCode || '').trim());
}

export function getGroupPracticalStationConfig(stationCode) {
  return GROUP_PRACTICAL_STATION_CONFIGS[String(stationCode || '').trim()] || GROUP_PRACTICAL_STATION_CONFIGS[SRHT_EXAM_STATION_GRUPPENPRUEFUNG];
}

export const GRUPPENPRUEFUNG_DESCRIPTION = [
  'Ein Dachdecker hat auf einem Flachdach einen Bandscheibenvorfall erlitten. Er kann nur in einer Trage optimal transportiert werden, es besteht keine Anleitermöglichkeit.',
  'Zugang über Steiganlage mit kompletter Ausrüstung. Während des Abseilens kommt es zu einem fiktiven Verhaken von Retter und Patient an der Struktur, so dass ein Aufziehen von 1 m Höhe notwendig ist. Im Anschluss wird die Trage mit Retter bis auf den Boden abgelassen.',
  'Die Zeitnahme beginnt im Dachbereich der Energiezentrale am Fuß der Steigleiter und endet, wenn die Person am Boden ist.',
  'Der Gruppe werden die Funktionen 1. Retter, 2. Retter, 1. Sicherer und 2. Sicherer zugewiesen. Ein Ausbilder führt die Gruppe.',
  'Die medizinische Versorgung wird nicht abgeprüft. Aufgaben können durch den Einheitsführer situativ angepasst werden.',
  'Auf der Dachfläche sowie an der Steiganlage ist bereits vor der Prüfung ein Seilgeländer installiert, welches während der Prüfung genutzt werden kann.',
];

export const GRUPPENPRUEFUNG_MATERIAL = [
  'Alle TN tragen die vollständige PSA inkl. HMS-Karabiner und Prusikschlinge',
  'Jeweils ein Service-Pack je TN und Einheitsführer, beim Einheitsführer zusätzlich 10 m Hilfsseil oder 20 m Prusiksystem',
  '2x Seilsack Standard (100 m-Seil / Plane / 2x Hilfsseil 10 m)',
  '2x Seil mind. 60 m in Seilsäcken',
  '1x Materialrucksack Standard',
  'Materialrucksack Patient',
  'Schleifkorbtrage',
  'Übungspuppe (90 kg) oder alternativ Patientendarsteller',
  'Das Material steht am Fuß der Steigschutzleiter (Startpunkt der Gruppe) bereit.',
];

function buildGruppenpruefungActionCatalog() {
  return GRUPPENPRUEFUNG_STANDARD_ACTIONS.map((action) => ({ ...action }));
}

function buildGroupPracticalActionCatalog(stationCode = SRHT_EXAM_STATION_GRUPPENPRUEFUNG) {
  return getGroupPracticalStationConfig(stationCode).standardActions.map((action) => ({ ...action }));
}

function buildGruppenpruefungParticipantSlots() {
  return GRUPPENPRUEFUNG_PARTICIPANT_POSITIONS.map((position, index) => ({
    slotId: `slot_${index + 1}`,
    positionId: position.id,
    positionLabel: position.label,
    candidateId: '',
    primaryExaminerUserId: '',
    outOfCompetition: false,
  }));
}

export function buildEmptyGruppenpruefungResult() {
  return {
    candidateId: '',
    groupId: '',
    slotId: '',
    primaryExaminerUserId: '',
    outOfCompetition: false,
    actionScores: {},
    remarks: '',
    status: 'draft',
    finalizedAt: null,
    finalizedByUserId: null,
    lastUnlockedAt: null,
    lastUnlockedByUserId: null,
    updatedAt: null,
  };
}

export function buildEmptyGruppenpruefungGroup(index = 0) {
  return {
    id: `group_${index + 1}`,
    label: `Gruppe ${index + 1}`,
    leaderExaminerUserId: '',
    timeLock: {
      isFinal: false,
      lockedAt: null,
      lockedByUserId: null,
    },
    safetyIncident: {
      answered: false,
      hasIncident: false,
      description: '',
    },
    actionCatalog: buildGruppenpruefungActionCatalog(),
    participants: buildGruppenpruefungParticipantSlots(),
    contributionEntries: [],
    timeEntries: [],
    nextContributionSequence: 1,
  };
}

function buildEmptyGroupPracticalStation(stationCode = SRHT_EXAM_STATION_GRUPPENPRUEFUNG) {
  return {
    selectedGroupId: 'group_1',
    selectedCandidateId: '',
    groups: [0, 1, 2].map((index) => ({
      ...buildEmptyGruppenpruefungGroup(index),
      actionCatalog: buildGroupPracticalActionCatalog(stationCode),
    })),
    resultsByCandidateId: {},
  };
}

function normalizeGruppenpruefungActionScoreValue(rawValue) {
  const numericValue = Number(rawValue);
  if (!Number.isFinite(numericValue) || !GROUP_PRUEFUNG_ALLOWED_POINTS.has(numericValue)) {
    return null;
  }

  return numericValue;
}

export function getGruppenpruefungActionScoresByAction(result = {}, group = {}) {
  const candidateId = String(result?.candidateId || '').trim();
  const groupedPointsByActionId = new Map();
  const fallbackActionScores = Object.fromEntries(
    Object.entries(result?.actionScores || {})
      .map(([actionId, entry]) => [actionId, normalizeGruppenpruefungActionScoreValue(entry?.points)])
      .filter(([, points]) => points != null),
  );

  if (String(result?.status || '').trim() === 'finalized' && Object.keys(fallbackActionScores).length > 0) {
    return fallbackActionScores;
  }

  if (candidateId) {
    (Array.isArray(group?.contributionEntries) ? group.contributionEntries : []).forEach((entry) => {
      if (String(entry?.participantCandidateId || '') !== candidateId) {
        return;
      }

      const normalizedPoints = normalizeGruppenpruefungActionScoreValue(entry?.points);
      if (normalizedPoints == null) {
        return;
      }

      const actionId = String(entry?.actionId || '').trim();
      if (!actionId) {
        return;
      }

      const existingPoints = groupedPointsByActionId.get(actionId) || [];
      groupedPointsByActionId.set(actionId, [...existingPoints, normalizedPoints]);
    });
  }

  if (groupedPointsByActionId.size > 0) {
    return Object.fromEntries(
      Array.from(groupedPointsByActionId.entries()).map(([actionId, points]) => ([
        actionId,
        Math.round(((points.reduce((sum, value) => sum + value, 0) / points.length) * 10)) / 10,
      ])),
    );
  }

  return fallbackActionScores;
}

function normalizeCandidateResultsByStation(rawResultsByCandidateId = {}, buildEmptyResult) {
  if (!rawResultsByCandidateId || typeof rawResultsByCandidateId !== 'object' || Array.isArray(rawResultsByCandidateId)) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(rawResultsByCandidateId).map(([candidateId, rawResult]) => {
      const baseResult = buildEmptyResult();
      const normalizedLegacyLaneId = String(rawResult?.laneId || '').trim();
      const mergedResult = {
        ...baseResult,
        ...(rawResult || {}),
        ...(normalizedLegacyLaneId ? { legacyLaneId: normalizedLegacyLaneId } : {}),
      };
      delete mergedResult.laneId;
      return [String(candidateId), mergedResult];
    }),
  );
}

function buildAktivrettungPointOptions(labels) {
  return [
    { points: 5, label: labels[5] || 'Sicheres, zügiges Handeln' },
    { points: 4, label: labels[4] || 'Schulmäßige Durchführung' },
    { points: 3, label: labels[3] || 'Erfüllt mit Defiziten' },
    { points: 2, label: labels[2] || 'Teilweise erfüllt' },
    { points: 1, label: labels[1] || 'Teilweise erfüllt mit Hilfe' },
    { points: 0, label: labels[0] || 'Nicht erfüllt' },
  ];
}

function buildEinzelueberpruefungPointOptions() {
  return [
    { points: 10, label: 'Sicheres fehlerfreies Handeln' },
    { points: 9, label: 'Korrekte Durchführung, Fehler selbst behoben' },
    { points: 8, label: 'Karabiner offen, schlechte Ordnung' },
    { points: 6, label: 'Mehrfache unterkritische Fehler' },
    { points: 5, label: 'Prüfer muss unterstützen' },
    { points: 0, label: 'Nicht erfüllt / Gefährdung' },
  ];
}

export const SRHT_EXAM_PRACTICAL_STATIONS = [
  {
    id: SRHT_EXAM_STATION_FITNESS_COORDINATION,
    title: '1. Fitness- & Koordinationsprüfung',
    subtitle: '',
    implemented: true,
  },
  {
    id: SRHT_EXAM_STATION_AKTIVRETTUNG,
    title: '2. Aktivrettung',
    subtitle: '',
    implemented: true,
  },
  {
    id: SRHT_EXAM_STATION_FALLSCHUTZ,
    title: '3. Person im Fallschutz',
    subtitle: '',
    implemented: true,
  },
  {
    id: SRHT_EXAM_STATION_GRUPPENPRUEFUNG,
    title: '4. Tragenrettung gleiches Niveau',
    subtitle: '',
    implemented: true,
  },
  {
    id: SRHT_EXAM_STATION_EINZELUEBERPRUEFUNG,
    title: '5. Einzelüberprüfung',
    subtitle: '',
    implemented: true,
  },
];

export const FITNESS_COORDINATION_SEQUENCE = [
  'Aufstieg mit I\'D und Steigklemme (vor dem Start vorbereitet) bis zum Kantenrohr (Anschlagen)',
  'Abseilen mit I\'D',
  'Aufstieg mit Croll und Steigklemme bis zum Kantenrohr (Anschlagen)',
  'Abseilen mit I\'D und freimachen der Abseilstrecken',
];

export const FITNESS_COORDINATION_EQUIPMENT = [
  'PSA inkl. HMS-Karabiner und Prusikschlinge sowie zwei Reepschnüren (alternativ Fußtrittschlinge)',
  'Vollständiges Service-Pack inkl. I\'D',
];

export const FITNESS_COORDINATION_NOTES = [
  'Es ist jederzeit redundant zu arbeiten. Die Sicherung im zweiten System erfolgt durch ein ASAP.',
  'Beim Aufsteigen mittels Croll ist eine Verbindung zwischen Gurt und Handsteigklemme obligat.',
  'Die Handsteigklemme selbst braucht nicht mittels Karabiner im Seil gesichert werden.',
  'Fußsteigklemmen und Kniesteigklemmen sind nicht gestattet.',
  'Eine Trittschlinge aus der mitgeführten Reepschnur kann vor Beginn erstellt und abgelegt werden.',
  'Die Lehrgangsteilnehmer dürfen bei der Seilführung unterstützen.',
  'Sicherheitsrelevante Fehler werden angesagt; die Zeitnahme läuft nach dem Beheben ohne Unterbrechung weiter.',
];

export const AKTIVRETTUNG_MAX_DURATION_MS = 30 * 60 * 1000;
export const AKTIVRETTUNG_TIMEPOINT_SECTION_IDS = ['section_1', 'section_2', 'section_3', 'section_4', 'section_5', 'section_7'];
export const AKTIVRETTUNG_SECTION_MAX_POINTS = 40;
export const AKTIVRETTUNG_TIME_MAX_POINTS = 5;
export const AKTIVRETTUNG_MAX_POINTS = 45;
export const AKTIVRETTUNG_GRADE_RANGES = [
  { grade: 1, label: 'Sehr gut', min: 42, max: 45 },
  { grade: 2, label: 'Gut', min: 37, max: 41 },
  { grade: 3, label: 'Befriedigend', min: 31, max: 36 },
  { grade: 4, label: 'Ausreichend', min: 23, max: 30 },
  { grade: 5, label: 'Mangelhaft', min: 14, max: 22 },
  { grade: 6, label: 'Ungenügend', min: 0, max: 13 },
];

export const AKTIVRETTUNG_TIME_POINT_RULES = [
  { maxMs: 8 * 60 * 1000, points: 5, label: '≤ 8 min' },
  { maxMs: 10 * 60 * 1000, points: 4, label: '> 8–10 min' },
  { maxMs: 15 * 60 * 1000, points: 3, label: '> 10–15 min' },
  { maxMs: 20 * 60 * 1000, points: 2, label: '> 15–20 min' },
  { maxMs: 30 * 60 * 1000, points: 1, label: '> 20–30 min' },
];

export const AKTIVRETTUNG_SECTION_DEFINITIONS = [
  {
    id: 'section_1',
    number: 1,
    title: 'Kontaktaufnahme / Führung / Notruf',
    capturesTimestamp: true,
    items: [
      'Kontaktaufnahme zum verunfallten Teilnehmer',
      'Information Übungsleitung / Gruppenführer',
      'Notruf',
    ],
    scoreOptions: buildAktivrettungPointOptions({
      5: 'Lage sofort erkannt, klar kommuniziert und vollständig gemeldet',
      4: 'Fehlerfrei und vollständig abgearbeitet',
      3: 'Lage erkannt, Kommunikation mit kleineren Defiziten',
      2: 'Wichtige Meldeteile fehlen oder kommen deutlich verspätet',
      1: 'Nur mit Hilfen des Prüfers eingeleitet',
      0: 'Nicht eingeleitet oder lagegefährdend unzureichend',
    }),
  },
  {
    id: 'section_2',
    number: 2,
    title: 'Vorgehen am Seilgeländer',
    capturesTimestamp: true,
    items: ['Vorgehen am Seilgeländer'],
    scoreOptions: buildAktivrettungPointOptions({
      5: 'Sicheres, zügiges Vorgehen am Seilgeländer',
      4: 'Saubere und schulmäßige Durchführung',
      3: 'Mit Defiziten, aber sicher im Ablauf',
      2: 'Unsicheres oder deutlich verzögertes Vorgehen',
      1: 'Nur mit kleinen Anweisungen vom Prüfer',
      0: 'Nicht beherrscht oder eingriffsbedürftig',
    }),
  },
  {
    id: 'section_3',
    number: 3,
    title: 'Eigene unabhängige Seilstrecke',
    capturesTimestamp: true,
    items: ['Errichtung einer eigenen unabhängigen Seilstrecke (redundant)'],
    scoreOptions: buildAktivrettungPointOptions({
      5: 'Seilstrecken fehlerfrei, zügig und nachvollziehbar aufgebaut',
      4: 'Fehlerfrei und nachvollziehbar aufgebaut',
      3: 'Redundanz vorhanden, aber Aufbau mit Defiziten',
      2: 'Aufbau nur teilweise schlüssig oder deutlich verzögert',
      1: 'Benötigt Hilfen beim Aufbau',
      0: 'Keine sichere redundante Lösung hergestellt',
    }),
  },
  {
    id: 'section_4',
    number: 4,
    title: 'Abseilen mittels I’D und ASAP',
    capturesTimestamp: true,
    items: ['Abseilen mittels I’D und ASAP'],
    scoreOptions: buildAktivrettungPointOptions({
      5: 'Sicheres, zügiges Abseilen mit I’D und ASAP',
      4: 'Schulmäßige Durchführung',
      3: 'Ablauf sicher, aber mit kleineren Defiziten',
      2: 'Teilweise erfüllt, unsauber oder deutlich stockend',
      1: 'Nur mit kleinen Anweisungen des Prüfers',
      0: 'Nicht sicher durchführbar',
    }),
  },
  {
    id: 'section_5',
    number: 5,
    title: 'Sicherung und Übernahme des Verunfallten',
    capturesTimestamp: true,
    items: [
      'Sicherung des Verunfallten',
      'Aufbau einer Umlenkung und Übernahme des Verunfallten ins eigene System',
    ],
    scoreOptions: buildAktivrettungPointOptions({
      5: 'Verunfallter sicher übernommen und sauber ins eigene System gebracht',
      4: 'Fehlerfreie und schulmäßige Übernahme',
      3: 'Umlenkung schlecht gewählt oder keine Ordnung im System',
      2: 'Mehr als drei Versuche bei der Befreiung / Übernahme',
      1: 'Benötigt kleine Anweisungen vom Prüfer',
      0: 'Übernahme scheitert oder gefährdet den Teilnehmer',
    }),
  },
  {
    id: 'section_6',
    number: 6,
    title: 'Seilordnung',
    capturesTimestamp: false,
    items: ['Seilordnung'],
    scoreOptions: buildAktivrettungPointOptions({
      5: 'Durchgehend geordnetes und kontrolliertes System',
      4: 'Saubere Seilordnung ohne relevante Mängel',
      3: 'Keine Ordnung im System, aber noch beherrscht',
      2: 'Teilweise erfüllt, Ordnung mehrfach verloren',
      1: 'Nur mit Hinweisen des Prüfers',
      0: 'Ungeordnete Seilführung mit Eingriffsbedarf',
    }),
  },
  {
    id: 'section_7',
    number: 7,
    title: 'Abseilen mit dem Verunfallten',
    capturesTimestamp: true,
    items: ['Abseilen mit dem Verunfallten über I’D (inkl. zusätzlicher Umlenkung)'],
    scoreOptions: buildAktivrettungPointOptions({
      5: 'Sicheres und kontrolliertes Abseilen des Verunfallten',
      4: 'Fehlerfreie schulmäßige Durchführung',
      3: 'Durchgeführt mit Defiziten im Bewegungsablauf',
      2: 'Teilweise erfüllt, deutlich stockend oder unruhig',
      1: 'Benötigt kleine Anweisungen des Prüfers',
      0: 'Nicht sicher beherrscht',
    }),
  },
  {
    id: 'section_8',
    number: 8,
    title: 'Kommunikation und Fehlermanagement',
    capturesTimestamp: false,
    items: ['Kommunikation', 'Fehlermanagement'],
    scoreOptions: buildAktivrettungPointOptions({
      5: 'Klare Kommunikation und vorausschauendes Fehlermanagement',
      4: 'Fehlerfreie Kommunikation im gesamten Ablauf',
      3: 'Kommunikation oder Fehlermanagement mit Defiziten',
      2: 'Teilweise erfüllt, wichtige Hinweise fehlen',
      1: 'Nur mit kleinen Anweisungen vom Prüfer',
      0: 'Kommunikation bricht weg oder Fehler werden nicht beherrscht',
    }),
  },
];

export const AKTIVRETTUNG_DESCRIPTION = 'Im Rahmen einer Übung (Aufsteigen/ Umbauen/ Abseilen mit zwei TN) erschöpft sich ein TN derart, dass er sich nicht alleine befreien kann. Der TN hängt auf einer Höhe von ca. 3–4 m regelkonform in Brust- und Handsteigklemme, Sicherung über ASAP. Der Prüfling erkennt die Situation, leitet die erforderlichen Maßnahmen ein und führt eine aktive Rettung mit Gegengewichtstechnik durch. Der Zugang erfolgt von oben (Deckenkonstruktion) mit dem vorbereiteten Interventionsmaterial, PSA und einem Service-Pack. Die Zeitnahme beginnt mit dem Aufstieg an der Treppe in die Deckenkonstruktion und endet sobald die Seilstrecke entlastet ist.';

export const AKTIVRETTUNG_MATERIAL = [
  'Teilnehmer hat die vollständige PSA (inkl. HMS-Karabiner und Prusikschlinge)',
  '1x Service-Pack',
  'ein Seil (100 m)',
  '1x Bandschlinge (80 cm)',
  '2x Bandschlinge (120 cm)',
  '2x X-Large-Karabiner',
];

export const EINZELUEBERPRUEFUNG_MAX_DURATION_MS = 35 * 60 * 1000;
export const EINZELUEBERPRUEFUNG_SECTION_DEFINITIONS = [
  { id: 'section_1', number: 1, title: 'Aufbau ASAP am Festpunkt inkl. Seileinbau, Überprüfung und Umlenkung (Sicherungsseil)', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
  { id: 'section_2', number: 2, title: 'Aufbau I\'D am Festpunkt inkl. Seileinbau und Überprüfung (Lastseil)', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
  { id: 'section_3', number: 3, title: 'I\'D hintersichern', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
  { id: 'section_4', number: 4, title: 'Aufziehen des Gewichtes mittels Expressflaschenzug (ca. 2 m)', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
  { id: 'section_5', number: 5, title: 'Umbauen und Aufziehen mittels Flaschenzug 5:1 mit Doppelrolle (ca. 5 m)', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
  { id: 'section_6', number: 6, title: 'Umbauen und Aufziehen mit Schweizer Flaschenzug (ca. 5 m bis kurz vor die Umlenkung unter der Decke)', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
  { id: 'section_7', number: 7, title: 'Ablassen mittels I\'D (ca. 4 m, maximal bis auf halbe Strecke zum Boden)', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
  { id: 'section_8', number: 8, title: 'Knoten (Seilverlängerung) durch das I\'D fahren', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
  { id: 'section_9', number: 9, title: 'Ablassen mittels I\'D (ca. 2 m)', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
  { id: 'section_10', number: 10, title: 'Umbau auf HMS', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
  { id: 'section_11', number: 11, title: 'Ablassen bis auf den Boden mittels HMS', items: [], scoreOptions: buildEinzelueberpruefungPointOptions() },
];

export const EINZELUEBERPRUEFUNG_TIME_POINT_RULES = [
  { maxMs: 20 * 60 * 1000, points: 10, label: '≤ 20 min' },
  { maxMs: 22 * 60 * 1000, points: 9, label: '> 20–22 min' },
  { maxMs: 25 * 60 * 1000, points: 8, label: '> 22–25 min' },
  { maxMs: 30 * 60 * 1000, points: 6, label: '> 25–30 min' },
  { maxMs: 35 * 60 * 1000, points: 5, label: '> 30–35 min' },
];

export const EINZELUEBERPRUEFUNG_GRADE_RANGES = [
  { grade: 1, label: 'Sehr gut', min: 110, max: 120 },
  { grade: 2, label: 'Gut', min: 97, max: 109 },
  { grade: 3, label: 'Befriedigend', min: 80, max: 96 },
  { grade: 4, label: 'Ausreichend', min: 60, max: 79 },
  { grade: 5, label: 'Mangelhaft', min: 36, max: 59 },
  { grade: 6, label: 'Ungenügend', min: 0, max: 35 },
];

export const EINZELUEBERPRUEFUNG_DESCRIPTION = [
  'Der Teilnehmer startet neben der Übungsstation.',
  'Im Vorfeld der Prüfung wird ein zentraler Festpunkt (Riggingplatte) durch die Prüfer installiert. Last- und Sicherungsseil sind in der Deckenkonstruktion über Rollen umgelenkt und am zentralen Festpunkt mittels Karabiner und Sackstich in der Riggingplatte festgelegt.',
  'Beide Seilstrecken sind auf der Lastseite in den Gurt der Übungspuppe eingebunden. Die Übungspuppe liegt auf dem Boden.',
  'Alternativ zur Übungspuppe können Gewichte von insgesamt 90 kg verwendet werden.',
];

export const EINZELUEBERPRUEFUNG_MATERIAL = [
  'Teilnehmer hat die vollständige PSA (Gurt, Helm, Handschuhe, HMS-Karabiner, Prusikschlinge)',
  '1 x Bandschlinge 120 cm',
  '1 x Bandschlinge 80 cm',
  '1 x I\'D',
  '2 x Einzelrollen',
  '1 x Doppelrolle',
  '2 x Handsteigklemme',
  '4 x X-Large Karabiner',
  '1 x 10 m Hilfsseil',
  '1 x ASAP',
  'Das Material liegt neben dem vorbereiteten Festpunkt sortiert bereit.',
];

export const FITNESS_COORDINATION_TIME_SOURCE_MEASURED = 'measured';
export const FITNESS_COORDINATION_TIME_SOURCE_CONTROLLER = 'controller';

export function buildPracticalSheetsStorageKey(examId) {
  if (!examId) {
    return '';
  }

  return `${SRHT_EXAM_PRACTICAL_SHEET_STORAGE_PREFIX}:${examId}`;
}

export function formatDuration(timeMs) {
  if (!Number.isFinite(Number(timeMs)) || Number(timeMs) < 0) {
    return '00:00';
  }

  const totalSeconds = Math.round(Number(timeMs) / 1000);
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
}

export function parseMmSsToMs(value) {
  const rawValue = String(value || '').trim();
  const match = rawValue.match(/^(\d{1,2}):(\d{2})$/);
  if (!match) {
    return null;
  }

  const minutes = Number(match[1]);
  const seconds = Number(match[2]);
  if (!Number.isFinite(minutes) || !Number.isFinite(seconds) || seconds > 59) {
    return null;
  }

  return (minutes * 60 + seconds) * 1000;
}

export function roundToSecondMs(value) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || numericValue < 0) {
    return 0;
  }

  return Math.round(numericValue / 1000) * 1000;
}

export function isFitnessCoordinationControlWithinTolerance(result = {}) {
  const measuredTotalMs = Number(result.totalMs || 0);
  const controlReferenceMs = Number(result.controllerReferenceMs || 0);
  if (!measuredTotalMs || !controlReferenceMs) {
    return false;
  }

  return Math.abs(controlReferenceMs - measuredTotalMs) <= 5000;
}

export function getFitnessCoordinationGrade(totalMs) {
  const numericValue = Number(totalMs);
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return null;
  }

  if (numericValue < 5.5 * 60 * 1000) return 1;
  if (numericValue <= 6.5 * 60 * 1000) return 2;
  if (numericValue <= 9 * 60 * 1000) return 3;
  if (numericValue <= 11 * 60 * 1000) return 4;
  if (numericValue <= 14 * 60 * 1000) return 5;
  return 6;
}

export function getFitnessCoordinationGradeLabel(grade) {
  if (!grade) {
    return 'Noch keine Note';
  }

  return `Note ${grade}`;
}

export function isFitnessCoordinationFailed(result = {}) {
  if (result?.safetyIncident?.hasIncident) {
    return true;
  }

  const grade = getFitnessCoordinationGrade(getEffectiveFitnessCoordinationTotalMs(result));
  return grade === 5 || grade === 6;
}

export function getFitnessCoordinationEffectiveTimeSource(result = {}) {
  const measuredTotalMs = Number(result.totalMs || 0);
  if (!measuredTotalMs) {
    return '';
  }

  const controlReferenceMs = Number(result.controllerReferenceMs || 0);
  if (!controlReferenceMs) {
    return FITNESS_COORDINATION_TIME_SOURCE_MEASURED;
  }

  if (!isFitnessCoordinationControlWithinTolerance(result)) {
    return controlReferenceMs < measuredTotalMs
      ? FITNESS_COORDINATION_TIME_SOURCE_CONTROLLER
      : FITNESS_COORDINATION_TIME_SOURCE_MEASURED;
  }

  return result.effectiveTimeSource === FITNESS_COORDINATION_TIME_SOURCE_CONTROLLER
    ? FITNESS_COORDINATION_TIME_SOURCE_CONTROLLER
    : FITNESS_COORDINATION_TIME_SOURCE_MEASURED;
}

export function getEffectiveFitnessCoordinationTotalMs(result = {}) {
  const measuredTotalMs = Number(result.totalMs || 0);
  if (!measuredTotalMs) {
    return 0;
  }

  const controlReferenceMs = Number(result.controllerReferenceMs || 0);
  if (!controlReferenceMs) {
    return measuredTotalMs;
  }

  return getFitnessCoordinationEffectiveTimeSource(result) === FITNESS_COORDINATION_TIME_SOURCE_CONTROLLER
    ? controlReferenceMs
    : measuredTotalMs;
}

export function getFitnessCoordinationDisplayMs(result = {}, runningElapsedMs = 0) {
  const measuredTotalMs = Number(result.totalMs || 0);
  if (measuredTotalMs > 0) {
    return measuredTotalMs;
  }

  const normalizedRunningElapsedMs = Number(runningElapsedMs || 0);
  if (normalizedRunningElapsedMs > 0) {
    return normalizedRunningElapsedMs;
  }

  return Math.max(
    Number(result.secondIntermediateMs || 0),
    Number(result.firstIntermediateMs || 0),
    0,
  );
}

export function getAktivrettungTimePoints(totalMs) {
  const numericValue = Number(totalMs || 0);
  if (!Number.isFinite(numericValue) || numericValue <= 0 || numericValue > AKTIVRETTUNG_MAX_DURATION_MS) {
    return 0;
  }

  const matchingRule = AKTIVRETTUNG_TIME_POINT_RULES.find((rule) => numericValue <= rule.maxMs);
  return matchingRule?.points || 0;
}

export function getAktivrettungSectionSum(result = {}) {
  return AKTIVRETTUNG_SECTION_DEFINITIONS.reduce((sum, section) => {
    const rawValue = Number(result.sectionScores?.[section.id]);
    return sum + (Number.isFinite(rawValue) && rawValue >= 0 ? rawValue : 0);
  }, 0);
}

export function getAktivrettungOverallPoints(result = {}) {
  return getAktivrettungSectionSum(result) + getAktivrettungTimePoints(result.totalMs);
}

export function getAktivrettungGrade(overallPoints) {
  const numericValue = Number(overallPoints);
  if (!Number.isFinite(numericValue) || numericValue < 0) {
    return null;
  }

  const matchingRange = AKTIVRETTUNG_GRADE_RANGES.find((range) => numericValue >= range.min && numericValue <= range.max);
  return matchingRange?.grade || null;
}

export function getAktivrettungGradeLabel(grade) {
  const matchingRange = AKTIVRETTUNG_GRADE_RANGES.find((range) => range.grade === Number(grade));
  if (!matchingRange) {
    return 'Noch keine Note';
  }

  return `Note ${matchingRange.grade} (${matchingRange.label})`;
}

export function isAktivrettungFailed(result = {}) {
  if (result?.safetyIncident?.hasIncident) {
    return true;
  }

  const totalMs = Number(result.totalMs || 0);
  if (totalMs > AKTIVRETTUNG_MAX_DURATION_MS) {
    return true;
  }

  const grade = getAktivrettungGrade(getAktivrettungOverallPoints(result));
  return grade === 5 || grade === 6;
}

export function getEinzelueberpruefungTimePoints(totalMs) {
  const numericValue = Number(totalMs || 0);
  if (!Number.isFinite(numericValue) || numericValue <= 0 || numericValue > EINZELUEBERPRUEFUNG_MAX_DURATION_MS) {
    return 0;
  }

  const matchingRule = EINZELUEBERPRUEFUNG_TIME_POINT_RULES.find((rule) => numericValue <= rule.maxMs);
  return matchingRule?.points || 0;
}

export function getEinzelueberpruefungSectionSum(result = {}) {
  return EINZELUEBERPRUEFUNG_SECTION_DEFINITIONS.reduce((sum, section) => {
    const rawValue = Number(result.sectionScores?.[section.id]);
    return sum + (Number.isFinite(rawValue) && rawValue >= 0 ? rawValue : 0);
  }, 0);
}

export function getEinzelueberpruefungOverallPoints(result = {}) {
  return getEinzelueberpruefungSectionSum(result) + getEinzelueberpruefungTimePoints(result.totalMs);
}

export function getEinzelueberpruefungGrade(overallPoints) {
  const numericValue = Number(overallPoints);
  if (!Number.isFinite(numericValue) || numericValue < 0) {
    return null;
  }

  const matchingRange = EINZELUEBERPRUEFUNG_GRADE_RANGES.find((range) => numericValue >= range.min && numericValue <= range.max);
  return matchingRange?.grade || null;
}

export function getEinzelueberpruefungGradeLabel(grade) {
  const matchingRange = EINZELUEBERPRUEFUNG_GRADE_RANGES.find((range) => range.grade === Number(grade));
  if (!matchingRange) {
    return 'Noch keine Note';
  }

  return `Note ${matchingRange.grade} (${matchingRange.label})`;
}

export function isEinzelueberpruefungFailed(result = {}) {
  if (result?.safetyIncident?.hasIncident) {
    return true;
  }

  const totalMs = Number(result.totalMs || 0);
  if (totalMs > EINZELUEBERPRUEFUNG_MAX_DURATION_MS) {
    return true;
  }

  const grade = getEinzelueberpruefungGrade(getEinzelueberpruefungOverallPoints(result));
  return grade === 5 || grade === 6;
}

export function getGruppenpruefungActionAverage(result = {}, group = {}) {
  const numericScores = Object.values(getGruppenpruefungActionScoresByAction(result, group));

  if (numericScores.length === 0) {
    return null;
  }

  return Math.round((numericScores.reduce((sum, value) => sum + value, 0) / numericScores.length) * 10) / 10;
}

export function getGruppenpruefungAverageTimeMs(group = {}) {
  const validTimeValues = (Array.isArray(group.timeEntries) ? group.timeEntries : [])
    .map((entry) => Number(entry?.totalMs || 0))
    .filter((value) => Number.isFinite(value) && value > 0);

  if (validTimeValues.length === 0) {
    return 0;
  }

  return validTimeValues[validTimeValues.length - 1];
}

export function getGroupPracticalTimePoints(totalMs, stationCode = SRHT_EXAM_STATION_GRUPPENPRUEFUNG) {
  const numericValue = Number(totalMs || 0);
  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return 0;
  }

  const matchingRule = getGroupPracticalStationConfig(stationCode).timePointRules.find((rule) => numericValue <= rule.maxMs);
  return matchingRule?.points || 0;
}

export function getGruppenpruefungTimePoints(totalMs) {
  return getGroupPracticalTimePoints(totalMs, SRHT_EXAM_STATION_GRUPPENPRUEFUNG);
}

export function getGroupPracticalOverallPoints(result = {}, group = {}, stationCode = SRHT_EXAM_STATION_GRUPPENPRUEFUNG) {
  const actionAverage = getGruppenpruefungActionAverage(result, group);
  const timePoints = getGroupPracticalTimePoints(getGruppenpruefungAverageTimeMs(group), stationCode);
  if (actionAverage == null && timePoints === 0) {
    return null;
  }

  return Math.round((((actionAverage || 0) + timePoints) * 10)) / 10;
}

export function getGruppenpruefungOverallPoints(result = {}, group = {}) {
  return getGroupPracticalOverallPoints(result, group, SRHT_EXAM_STATION_GRUPPENPRUEFUNG);
}

export function getGroupPracticalGrade(overallPoints, stationCode = SRHT_EXAM_STATION_GRUPPENPRUEFUNG) {
  const numericValue = Number(overallPoints);
  if (!Number.isFinite(numericValue) || numericValue < 0) {
    return null;
  }

  const matchingRange = getGroupPracticalStationConfig(stationCode).gradeRanges.find((range) => numericValue >= range.min && numericValue <= range.max);
  return matchingRange?.grade || null;
}

export function getGruppenpruefungGrade(overallPoints) {
  return getGroupPracticalGrade(overallPoints, SRHT_EXAM_STATION_GRUPPENPRUEFUNG);
}

export function getGroupPracticalGradeLabel(grade, stationCode = SRHT_EXAM_STATION_GRUPPENPRUEFUNG) {
  const matchingRange = getGroupPracticalStationConfig(stationCode).gradeRanges.find((range) => range.grade === Number(grade));
  if (!matchingRange) {
    return 'Noch keine Note';
  }

  return `Note ${matchingRange.grade} (${matchingRange.label})`;
}

export function getGruppenpruefungGradeLabel(grade) {
  return getGroupPracticalGradeLabel(grade, SRHT_EXAM_STATION_GRUPPENPRUEFUNG);
}

export function isGroupPracticalFailed(result = {}, group = {}, stationCode = SRHT_EXAM_STATION_GRUPPENPRUEFUNG) {
  if (group?.safetyIncident?.hasIncident) {
    return true;
  }

  if (getGruppenpruefungAverageTimeMs(group) > getGroupPracticalStationConfig(stationCode).maxDurationMs) {
    return true;
  }

  const grade = getGroupPracticalGrade(getGroupPracticalOverallPoints(result, group, stationCode), stationCode);
  return grade === 5 || grade === 6;
}

export function isGruppenpruefungFailed(result = {}, group = {}) {
  return isGroupPracticalFailed(result, group, SRHT_EXAM_STATION_GRUPPENPRUEFUNG);
}

export function buildEmptyFitnessCoordinationResult() {
  return {
    examinerUserId: '',
    controllerUserId: '',
    firstIntermediateMs: 0,
    secondIntermediateMs: 0,
    totalMs: 0,
    controllerReferenceMs: 0,
    effectiveTimeSource: FITNESS_COORDINATION_TIME_SOURCE_MEASURED,
    status: 'draft',
    finalizedAt: null,
    finalizedByUserId: null,
    lastUnlockedAt: null,
    lastUnlockedByUserId: null,
    remarks: '',
    safetyIncident: {
      answered: false,
      hasIncident: false,
      description: '',
    },
    updatedAt: null,
  };
}

export function buildEmptyAktivrettungResult() {
  return {
    examinerUserId: '',
    controllerUserId: '',
    totalMs: 0,
    sectionTimes: Object.fromEntries(AKTIVRETTUNG_TIMEPOINT_SECTION_IDS.map((sectionId) => [sectionId, 0])),
    sectionScores: Object.fromEntries(AKTIVRETTUNG_SECTION_DEFINITIONS.map((section) => [section.id, ''])),
    status: 'draft',
    finalizedAt: null,
    finalizedByUserId: null,
    lastUnlockedAt: null,
    lastUnlockedByUserId: null,
    remarks: '',
    safetyIncident: {
      answered: false,
      hasIncident: false,
      description: '',
    },
    updatedAt: null,
  };
}

export function buildEmptyEinzelueberpruefungResult() {
  return {
    examinerUserId: '',
    controllerUserId: '',
    totalMs: 0,
    sectionScores: Object.fromEntries(EINZELUEBERPRUEFUNG_SECTION_DEFINITIONS.map((section) => [section.id, ''])),
    status: 'draft',
    finalizedAt: null,
    finalizedByUserId: null,
    lastUnlockedAt: null,
    lastUnlockedByUserId: null,
    remarks: '',
    safetyIncident: {
      answered: false,
      hasIncident: false,
      description: '',
    },
    updatedAt: null,
  };
}

export function buildInitialPracticalSheetsState() {
  return {
    activeStationId: SRHT_EXAM_STATION_FITNESS_COORDINATION,
    stations: {
      [SRHT_EXAM_STATION_FITNESS_COORDINATION]: {
        selectedCandidateId: '',
        resultsByCandidateId: {},
      },
      [SRHT_EXAM_STATION_AKTIVRETTUNG]: {
        selectedCandidateId: '',
        resultsByCandidateId: {},
      },
      [SRHT_EXAM_STATION_FALLSCHUTZ]: buildEmptyGroupPracticalStation(SRHT_EXAM_STATION_FALLSCHUTZ),
      [SRHT_EXAM_STATION_GRUPPENPRUEFUNG]: buildEmptyGroupPracticalStation(SRHT_EXAM_STATION_GRUPPENPRUEFUNG),
      [SRHT_EXAM_STATION_EINZELUEBERPRUEFUNG]: {
        selectedCandidateId: '',
        resultsByCandidateId: {},
      },
    },
  };
}

export function buildPracticalSheetsStateFromSavedSheets(savedSheets = {}, fallbackState = null) {
  const baseState = fallbackState?.stations ? fallbackState : buildInitialPracticalSheetsState();
  const savedFitnessCoordinationSheet = savedSheets?.[SRHT_EXAM_STATION_FITNESS_COORDINATION] || null;
  const savedFitnessCoordinationPayload = savedSheets?.[SRHT_EXAM_STATION_FITNESS_COORDINATION]?.rawPayload;
  const savedAktivrettungSheet = savedSheets?.[SRHT_EXAM_STATION_AKTIVRETTUNG] || null;
  const savedAktivrettungPayload = savedSheets?.[SRHT_EXAM_STATION_AKTIVRETTUNG]?.rawPayload;
  const savedFallschutzSheet = savedSheets?.[SRHT_EXAM_STATION_FALLSCHUTZ] || null;
  const savedFallschutzPayload = savedSheets?.[SRHT_EXAM_STATION_FALLSCHUTZ]?.rawPayload;
  const savedGruppenpruefungSheet = savedSheets?.[SRHT_EXAM_STATION_GRUPPENPRUEFUNG] || null;
  const savedGruppenpruefungPayload = savedSheets?.[SRHT_EXAM_STATION_GRUPPENPRUEFUNG]?.rawPayload;
  const savedEinzelueberpruefungSheet = savedSheets?.[SRHT_EXAM_STATION_EINZELUEBERPRUEFUNG] || null;
  const savedEinzelueberpruefungPayload = savedSheets?.[SRHT_EXAM_STATION_EINZELUEBERPRUEFUNG]?.rawPayload;

  return {
    ...baseState,
    activeStationId: baseState.activeStationId || SRHT_EXAM_STATION_FITNESS_COORDINATION,
    stations: {
      ...baseState.stations,
      [SRHT_EXAM_STATION_FITNESS_COORDINATION]: savedFitnessCoordinationSheet
        ? {
          ...(baseState.stations?.[SRHT_EXAM_STATION_FITNESS_COORDINATION] || {}),
          selectedCandidateId: String(savedFitnessCoordinationPayload?.selectedCandidateId || baseState.stations?.[SRHT_EXAM_STATION_FITNESS_COORDINATION]?.selectedCandidateId || ''),
          resultsByCandidateId: normalizeCandidateResultsByStation(
            savedFitnessCoordinationPayload?.resultsByCandidateId,
            buildEmptyFitnessCoordinationResult,
          ),
        }
        : (baseState.stations?.[SRHT_EXAM_STATION_FITNESS_COORDINATION] || buildInitialPracticalSheetsState().stations[SRHT_EXAM_STATION_FITNESS_COORDINATION]),
      [SRHT_EXAM_STATION_AKTIVRETTUNG]: savedAktivrettungSheet
        ? {
          ...(baseState.stations?.[SRHT_EXAM_STATION_AKTIVRETTUNG] || {}),
          selectedCandidateId: String(savedAktivrettungPayload?.selectedCandidateId || baseState.stations?.[SRHT_EXAM_STATION_AKTIVRETTUNG]?.selectedCandidateId || ''),
          resultsByCandidateId: normalizeCandidateResultsByStation(
            savedAktivrettungPayload?.resultsByCandidateId,
            buildEmptyAktivrettungResult,
          ),
        }
        : (baseState.stations?.[SRHT_EXAM_STATION_AKTIVRETTUNG] || buildInitialPracticalSheetsState().stations[SRHT_EXAM_STATION_AKTIVRETTUNG]),
      [SRHT_EXAM_STATION_FALLSCHUTZ]: savedFallschutzSheet
        ? {
          ...(baseState.stations?.[SRHT_EXAM_STATION_FALLSCHUTZ] || {}),
          ...savedFallschutzPayload,
        }
        : (baseState.stations?.[SRHT_EXAM_STATION_FALLSCHUTZ] || buildInitialPracticalSheetsState().stations[SRHT_EXAM_STATION_FALLSCHUTZ]),
      [SRHT_EXAM_STATION_GRUPPENPRUEFUNG]: savedGruppenpruefungSheet
        ? {
          ...(baseState.stations?.[SRHT_EXAM_STATION_GRUPPENPRUEFUNG] || {}),
          ...savedGruppenpruefungPayload,
        }
        : (baseState.stations?.[SRHT_EXAM_STATION_GRUPPENPRUEFUNG] || buildInitialPracticalSheetsState().stations[SRHT_EXAM_STATION_GRUPPENPRUEFUNG]),
      [SRHT_EXAM_STATION_EINZELUEBERPRUEFUNG]: savedEinzelueberpruefungSheet
        ? {
          ...(baseState.stations?.[SRHT_EXAM_STATION_EINZELUEBERPRUEFUNG] || {}),
          selectedCandidateId: String(savedEinzelueberpruefungPayload?.selectedCandidateId || baseState.stations?.[SRHT_EXAM_STATION_EINZELUEBERPRUEFUNG]?.selectedCandidateId || ''),
          resultsByCandidateId: normalizeCandidateResultsByStation(
            savedEinzelueberpruefungPayload?.resultsByCandidateId,
            buildEmptyEinzelueberpruefungResult,
          ),
        }
        : (baseState.stations?.[SRHT_EXAM_STATION_EINZELUEBERPRUEFUNG] || buildInitialPracticalSheetsState().stations[SRHT_EXAM_STATION_EINZELUEBERPRUEFUNG]),
    },
  };
}